import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterDeleteIfNilService {

  constructor() {
  }

  /**
   * for delete useless null data
   * and pluck by id key
   *
   * @filter: PlayerFilter (list = {id, name}, other = simpleData)
   * */
  // tslint:disable-next-line:no-any
  flatten(filter: any): any {
    for (const key in filter) {
      if (filter.hasOwnProperty(key)) {

        // get id value plucked in flattened value
        if (filter[key] === null
          || filter[key] === undefined
          || filter[key] === 'Invalid date'
          || filter[key].length === 0) {
          delete filter[key];
        } else if ( typeof filter[key] === 'object'
          && (filter[key].id === null
          || filter[key].id === undefined
          || filter[key].id.length === 0)) {
          delete filter[key];
        } else if (filter[key].id) {
          filter[key] = filter[key].id
        }

      }
    }
    return filter;
  }
}
